import { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import CentralModal from "../Modals/CentralModal";
import { ConfirmDialogStyles } from "./confirmDialog.styles";

const EXIT_DURATION = 300;

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm",
  message = "Are you sure?",
  confirmText = "Delete",
  cancelText = "Cancel",
  danger = true,
}) => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let frameId;
    let timeoutId;

    if (isOpen) {
      setShouldRender(true);
      frameId = requestAnimationFrame(() => {
        frameId = requestAnimationFrame(() => setIsVisible(true));
      });
    } else {
      setIsVisible(false);
      timeoutId = setTimeout(() => setShouldRender(false), EXIT_DURATION);
    }

    return () => {
      if (frameId) cancelAnimationFrame(frameId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [isOpen]);

  if (!shouldRender) return null;

  return ReactDOM.createPortal(
    <CentralModal isOpen={isVisible} closeModal={onClose}>
      <ConfirmDialogStyles>
        <h3 className="confirmTitle">{title}</h3>
        <p className="confirmMessage">{message}</p>
        <div className="confirmActions">
          <button className="cancelBtn" onClick={onClose}>
            {cancelText}
          </button>
          <button
            className={`confirmBtn${danger ? "" : " accent"}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </ConfirmDialogStyles>
    </CentralModal>,
    document.body
  );
};

export default ConfirmDialog;
